import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useInstanceId } from 'shared/src/hooks';
import { changeDefaultAddress } from 'mypage/src/api/addressService';
import { queryKey } from '../../../constant/queryKey';

export const useChangeDefaultAddress = () => {
  const client = useQueryClient();
  const instanceId = useInstanceId();
  return useMutation({
    mutationFn: changeDefaultAddress,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: queryKey.addresses(instanceId) });
    },
  });
};
